import axios, { AxiosRequestConfig } from 'axios'
import { url, credentials } from 'src/provider/config/constant'
import access from 'src/utils/localAccess'


const instance = axios.create({
    baseURL:  url.AUTH_BASE_URL 
})

instance.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        const token = await localStorage.getItem('token')
        config.headers!['Ocp-Apim-Subscription-Key'] = credentials.API_REQUEST_SECRET_KEY
        config.headers!['Access-Control-Allow-Origin'] = '*'
        
        if(token) {
            config.headers!.Authorization = `Bearer ${token}`
        }
        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)

export default instance